import { UserWorkoutSession } from 'fitbeat.gym-core';
import { CardioOrResistance } from 'fitbeat.models';
import { Logger } from '../../utils';
import ConnectedWorkoutApp,
{
  AuthorizationStatus,
  HREventListener,
  IPrepareHomeWorkout,
  IPrepareStudioWorkout,
  UnRegisterEventListener,
  IAuthorizationResult,
} from '../connected-workout-app';

abstract class LoggingConnectedApp extends ConnectedWorkoutApp {
  public async debugTestIntegration(): Promise<void> {
    Logger.debug(`${this.name}: debugTestIntegration`);
  }

  public async requestAuthorization(): Promise<IAuthorizationResult> {
    Logger.debug(`${this.name}: requestAuthorization`);
    return { success: true };
  }

  public async authorizationStatus(): Promise<AuthorizationStatus> {
    return AuthorizationStatus.authorized;
  }

  public async stopAndSaveWorkout(
    workoutSession: UserWorkoutSession,
  ): Promise<string | void> {
    Logger.debug(`${this.name}: stopAndSaveWorkout ${workoutSession.uniqueReference}`);
  }

  public async pauseWorkout(): Promise<void> {
    Logger.debug(`${this.name}: pauseWorkout`);
  }

  public async resumeWorkout(): Promise<void> {
    Logger.debug(`${this.name}: resumeWorkout`);
  }

  public async prepareStudioWorkout(options: IPrepareStudioWorkout): Promise<void> {
    Logger.debug(`${this.name}: prepare studio workout for ${JSON.stringify(options)}`);
  }

  public async prepareHomeWorkout(options: IPrepareHomeWorkout): Promise<void> {
    Logger.debug(`${this.name}: prepareHomeWorkout ${options.userId} ${options.activityType}`);
  }

  public async startWorkout(): Promise<void> {
    Logger.debug(`${this.name}: startWorkout`);
  }

  public async stopAndDiscardWorkout(): Promise<void> {
    Logger.debug(`${this.name}: stopAndDiscardWorkout`);
  }

  public async isAppInstalledOnConnectedDevice(): Promise<boolean> {
    Logger.debug(`${this.name}: isAppInstalledOnConnectedDevice`);
    return false;
  }

  public async isConnectedDeviceAvailable(): Promise<boolean> {
    Logger.debug(`${this.name}: isConnectedDeviceAvailable`);
    return false;
  }

  public async canUseAsRealtimeHeartRateMonitor(): Promise<boolean> {
    return false;
  }

  public registerHREventHandler(listener: HREventListener): UnRegisterEventListener {
    Logger.debug(`${this.name}: registerHREventHandler`);
    return () => {
      Logger.debug(`${this.name}: registerHREventHandler: unregistered`);
    };
  }
}

export default LoggingConnectedApp;
